// extracted by mini-css-extract-plugin
module.exports = {"containerSpinner":"styles_containerSpinner__3S066"};